import { Flex } from 'antd';
import {
  useAppSelector,
  useDeptProjectName,
  useRequestTypeFinderById,
  useStatusFinderByNum,
  useWorkLocationType,
} from '@Hooks/index';
import { useGetHrmRequestFormQuery } from '@Store/api/basicHrmApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { Status } from '@Components/Base';

import {
  getAttendanceReasonsDict,
  getCompaniesDictSelector,
} from '@Store/selectors/dictionarySelector';
import { TypeDict } from '@Types/index';

import fieldSource from './FieldSource';

import styles from './view-form.module.css';

const RequestViewForm: React.FC = () => {
  const companies = useAppSelector(getCompaniesDictSelector);
  const reasonsType = useAppSelector(getAttendanceReasonsDict);

  const { findStatus } = useStatusFinderByNum('Attendance');
  const { findRequestType } = useRequestTypeFinderById('Attendance');
  const { findWorkLocationType } = useWorkLocationType();
  const { findDeptProjName } = useDeptProjectName();
  const requestId = useAppSelector(getModalRecordKey);
  const { data } = useGetHrmRequestFormQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });

  if (!data) return null;

  const findReasonType = (reasonId: number): TypeDict | undefined =>
    reasonsType.find((item) => item.codeNum === reasonId);

  return (
    <Flex className={styles.viewForm} vertical>
      {fieldSource({
        data,
        companies,
        findRequestType,
        findWorkLocationType,
        findDeptProjName,
        findReasonType,
      }).map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>
          {item.label === 'Status' ? (
            <Status
              className={styles.viewItemValue}
              text={findStatus(Number(item.value))?.codeDesc || ''}
            />
          ) : (
            <span className={styles.viewItemValue}>{item.value}</span>
          )}
        </div>
      ))}
    </Flex>
  );
};

export default RequestViewForm;
